import Image from '@/components/UI/Image';
import EFArrowLeftSmall from '@/components/UI/svg/Icons/EFArrowLeftSmall';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import style from './index.module.scss';
const { EFPic } = createEFPic('/media/collection/');

const maxWidth = 1120;
export default function SolarTopNav({ navList = [], query = '', powerActiveKey = '' }: any) {
    const { Link, useEffect, useState, useLang } = useGlobal();
    const itemWidth = 180;
    const [wrapperW, setWrapperW] = useState(0);
    const [rightValue, setRightValue] = useState(0);
    const [hasScrollBtn, setHasScrollBtn] = useState(false);
    const { t } = useLang('shared');
    useEffect(() => {
        if (navList.length > 0) {
            const tempWrapperW = navList.length * itemWidth;
            const tempWidth = Math.max(document.body.clientWidth, maxWidth);
            setWrapperW(tempWrapperW);
            if (tempWrapperW > tempWidth) {
                setHasScrollBtn(true);
            } else {
                setHasScrollBtn(false);
                setRightValue(0);
            }
        }
    }, [navList]);

    useEffect(() => {
        let tempWidth;
        const pageResize = () => {
            requestAnimationFrame(() => {
                tempWidth = Math.max(document.body.clientWidth, maxWidth);
                if (wrapperW > tempWidth) {
                    setHasScrollBtn(true);
                } else {
                    setHasScrollBtn(false);
                    setRightValue(0);
                }
            });
        };
        window.addEventListener('resize', pageResize);
        return function () {
            window.removeEventListener('resize', pageResize);
        };
    }, [wrapperW]);

    const scrollForward = (forward: string) => {
        if (forward === 'right') {
            const tempWidth = Math.max(document.body.clientWidth, maxWidth);
            setRightValue(wrapperW - tempWidth);
            return;
        }
        setRightValue(0);
    };

    const getDataLayer = (conts: any) => {
        const queryMap: any = {
            power: 'Portable Power Stations',
            solutions: 'Solutions',
            'solar-generators': 'Solar Panels',
            solar: 'Solar Panels',
            smart: 'Smart Home',
        };
        const firstName = queryMap[query] || '';
        let secondName = '';
        if (query === 'power' || query === 'portable-power-stations') {
            secondName = powerActiveKey === 'delta' ? 'DELTA Series' : 'RIVER Series';
        }
        if (query === 'solar-generators') {
            secondName = powerActiveKey === 'generators' ? 'Solar Generators' : 'Solar Panels';
        }
        let thirdName = conts.name;
        // 配件页,对比页
        if (conts.isComparison || conts.isAccessories || conts.isIconName) {
            thirdName = conts.iconName;
        }
        return {
            event: 'uaEvent',
            event_name: 'top_third_navigation',
            navigation_name: `${firstName}_${secondName}_${thirdName}`,
        };
    };

    return (
        <div className={style.solarTopnav}>
            <div className={`nav-wrapper${hasScrollBtn ? ' full-wid' : ' fit-cont'}`}>
                {hasScrollBtn && rightValue > 0 && (
                    <div className="move-left" onClick={() => scrollForward('left')}>
                        <EFArrowLeftSmall />
                    </div>
                )}
                {hasScrollBtn && rightValue === 0 && (
                    <div className="move-right" onClick={() => scrollForward('right')}>
                        <EFArrowLeftSmall />
                    </div>
                )}
                <div style={{ right: `${rightValue}px` }} className="nav-list">
                    {navList.map(
                        (item: any, indx: number) =>
                            item.detLink && (
                                <div key={indx} className="navitem">
                                    <Link href={item.detLink} target={item.target || '_self'} dataLayer={getDataLayer(item)}>
                                        <div className="img-wrapper">
                                            {item.imgSrc ? (
                                                Array.isArray(item.imgSrc) ? (
                                                    <EFPic
                                                        name={item.imgSrc}
                                                        className="containImgs"
                                                        alt="DELTA Pro Solar Generators"
                                                        aria-label="DELTA Pro Solar Generators"
                                                    />
                                                ) : (
                                                    <Image
                                                        src={item.imgSrc}
                                                        layout="fill"
                                                        className="containImgs"
                                                        noUseSrcset={true}
                                                        alt="DELTA Pro Solar Generators"
                                                        aria-label="DELTA Pro Solar Generators"
                                                    />
                                                )
                                            ) : (
                                                item.icons
                                            )}
                                        </div>
                                        <div className="item-name">
                                            {item.name}
                                            {item.tag && item.tag === 'New' && (
                                                <p
                                                    className="tag"
                                                    style={{ color: '#fa4500', lineHeight: '22px', fontSize: '12px', display: 'block', marginLeft: 0 }}
                                                >
                                                    {t('product.nav_new')}
                                                </p>
                                            )}
                                            {item.tag && item.tag !== 'New' && <p className="tag">{item.tag}</p>}
                                        </div>
                                    </Link>
                                </div>
                            ),
                    )}
                </div>
            </div>
        </div>
    );
}
